import { render } from "./Sizes.vue?vue&type=template&id=c74ed678"
import script from "./Sizes.vue?vue&type=script&lang=ts"
export * from "./Sizes.vue?vue&type=script&lang=ts"
script.render = render

export default script